import { isValidObject } from '@nykaa/utils/validations';
import { RawPriceRevealInfo, RawSaleTemplateCardInfo } from 'types/priceReveal';

export const transformPriceRevealData = (
  prData: RawPriceRevealInfo,
  templateData: RawSaleTemplateCardInfo
) => {
  if (!isValidObject(prData) && !isValidObject(templateData)) {
    return null;
  }
  return {
    price: templateData ? templateData.price : prData.sp,
    discount: templateData ? templateData.discount : prData.discount,
    templateType: templateData?.template_type,
    text: templateData?.text,
    textColor: templateData?.text_color,
    priceColor: templateData?.price_color,
    discountColor: templateData?.discount_color,
    borderRadius: templateData?.border_radius,
    bgColor: templateData?.bg_color,
    imageUrl: templateData?.right_image_url || '',
    imageAspectRatio: templateData?.right_image_aspect_ratio?.web || '',
  };
};
